export default __webpack_public_path__ + "static/media/sidebar_dashboard_gray.40d9352a.svg";